export { VarlockExecError, execSyncVarlock, integrationTelemetryEnv } from '../chunk-GLMVGPQC.js';
import '../chunk-4IHYJA4S.js';
//# sourceMappingURL=exec-sync-varlock.js.map
//# sourceMappingURL=exec-sync-varlock.js.map